import { CacheStrategy } from '@rammetec/data-access';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { EXTERNAL_REF } from '../types/externalRef.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for external-system correspondence
 * (org/{orgId}/external-ref). Deterministic id via {@link externalRefId}.
 *
 * No lifecycle / audit — mapping row, not a business record.
 * No FK on `localId` — pointer of correspondence, not a business relationship
 * (would drag label/lookup onto a technical table).
 */
export const externalRefDescriptor = {
    name: EXTERNAL_REF,
    label: 'Referência externa',
    domain: 'integration',
    collectionPath: 'org/{orgId}/external-ref',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Maps an external system id to a SysColect local id',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: sync reads the full map every run; InMemory risked serving a stale
        // allComplete set and treating newly written refs as missing → duplicate Products
        // (see data-access/docs/requests/0015). Nobody else reads ExternalRef.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'systemKey',
            label: 'Sistema de origem',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_SYSTEM_KEY,
            description: "Ex.: 'vh:data-product'",
        },
        {
            name: 'entityName',
            label: 'Entidade',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_ENTITY_NAME,
            description: "Ex.: 'Product'",
        },
        {
            name: 'externalId',
            label: 'Id externo',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_ID,
        },
        {
            name: 'localId',
            label: 'Id local',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        {
            name: 'sourceHash',
            label: 'Hash da origem',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.SHA256,
        },
        { name: 'syncedAt', label: 'Sincronizado em', type: 'date', display: 'datetime', required: false },
    ],
};
//# sourceMappingURL=external-ref.descriptor.js.map